import React, { useState } from 'react';
import './UserAvatar.css';

export default function UserAvatar({ user, size = 'medium', onClick, className = '' }) {
  const [imageError, setImageError] = useState(false);

  if (!user) return null;

  const sizeClasses = {
    small: 'avatar-small',
    medium: 'avatar-medium',
    large: 'avatar-large'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.medium;
  const displayName = user.displayName || user.email?.split('@')[0] || 'U';
  const initials = displayName.charAt(0).toUpperCase();
  const photoURL = user.photoURL;
  const showImage = photoURL && !imageError;

  return (
    <div
      className={`user-avatar ${sizeClass} ${onClick ? 'avatar-clickable' : ''} ${className}`}
      onClick={onClick}
      title={user.email}
    >
      {showImage ? (
        <img
          src={photoURL}
          alt={displayName}
          className="avatar-image"
          onError={() => setImageError(true)}
        />
      ) : null}
      <div className="avatar-initials" style={{ display: showImage ? 'none' : 'flex' }}>
        {initials}
      </div>
    </div>
  );
}

